module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/uni_left-5d4fd887403098857c92eba1fcd86dba.svg";